import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material';
import { tokens } from '@app/theme/themes';
import { forwardRef } from 'react';

const StyledTextField = forwardRef(({ sx, ...props }, ref) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <TextField
            ref={ref}
            {...props}
            sx={{
                '& label.Mui-focused': {
                    color: colors.secondary[100],
                },
                '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                        borderColor: colors.secondary[100],
                    },
                },
                ...(sx ?? {}),
            }}
        />
    );
});

export default StyledTextField;
